type RankMotion={eventId:string;animation:Animation};
type Listener=(motion:RankMotion)=>void;
const ranks=new WeakMap<HTMLElement,RankMotion>();
const listeners=new WeakMap<HTMLElement,Set<Listener>>();

// One bridge per moving rendered card; no React frame updates or timeout queue.
// A same-ball stage update can extend a pending mark until the new move lands.
export function registerCardRankMotion(card:HTMLElement,eventId:string,animation:Animation){
 const motion={eventId,animation};ranks.set(card,motion);
 for(const listener of listeners.get(card)??[])listener(motion);
 return()=>{if(ranks.get(card)===motion)ranks.delete(card);};
}
export function followCardRankMotion(card:HTMLElement,eventId:string,onLanding:(at:number)=>void){
 const listener:Listener=motion=>{
  if(motion.eventId!==eventId||['idle','finished'].includes(motion.animation.playState))return;
  const start=motion.animation.startTime,end=motion.animation.effect?.getComputedTiming().endTime;
  if(typeof start==='number'&&typeof end==='number'&&Number.isFinite(start+end))onLanding(start+end);
 };
 const set=listeners.get(card)??new Set<Listener>();set.add(listener);listeners.set(card,set);
 const current=ranks.get(card);if(current)listener(current);
 return()=>{set.delete(listener);if(!set.size&&listeners.get(card)===set)listeners.delete(card);};
}
